module.exports = __webpack_public_path__ + "static/media/pic3.47738889.jpg";